export default __webpack_public_path__ + "img/bJVIlPhd.29c12edf.svg";